
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M.467.342h31.217v31.217H.467z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M13.596 11.29l.114 9.328 7.495-4.761-7.609-4.567zm-.843 12.07a.98.98 0 01-.977-.966l-.155-12.832a.975.975 0 011.48-.85l10.466 6.285a.976.976 0 01.02 1.661l-10.31 6.549a.962.962 0 01-.524.154z","fill":"currentColor"}}),_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('path',{attrs:{"d":"M16.076.342C7.47.342.467 7.344.467 15.95c0 8.606 7.003 15.609 15.609 15.609s15.608-7.003 15.608-15.609S24.682.342 16.076.342m0 1.954c7.54 0 13.654 6.112 13.654 13.654s-6.114 13.654-13.654 13.654c-7.542 0-13.654-6.112-13.654-13.654S8.534 2.296 16.076 2.296","fill":"currentColor","mask":"url(#b)"}})])])
          )
        }
      }
    